/* eslint-disable */

var numOfCharsInShortComment = typeof(maxNumOfCommentChars) !== "undefined" && window.maxNumOfCommentChars  ? window.maxNumOfCommentChars : 340;

let CommentEntity = Backbone.Epoxy.Model.extend({
	defaults: {
		id: null,
		user: null,
		created:null,
		text:'',
		rate: null,
		mealRate:null,
		serviceRate: null,
		locationRate:null,
		showFull:false
	},
	computeds: {
		showPreview: function() {
			var comentText = this.get('text');

			if(comentText.length > numOfCharsInShortComment) {
				return true;
			} else {
				return false;
			}
		},
		shortText:function() {
			var comentText = this.get('text');

			if(comentText.length > numOfCharsInShortComment) {
				return comentText.substr(0, numOfCharsInShortComment) + '...';
			} else {
				return comentText;
			}
		}
	}
});

export default CommentEntity;